import styled from "styled-components";
import Landing from "../../assets/icons/LandingPage.png";
import { RiSearch2Line } from "react-icons/ri";

export const SupportContainer = styled.div`
  background-image: url("/assets/icons/LandingPage.jpg");
  background-size: cover;
`;
export const SupportInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const SupportWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
`;

export const SupportHeader = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 60px;
  font-weight: 700;
  line-height: 78px;
  letter-spacing: 0.5px;
  color: #09005b;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    font-size: 30px;
    line-height: 34.35px;
    text-align: center;
  }
`;

export const SupportSearch = styled.div`
  width: 50%;
  border: 1px solid #5e5e5e;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 56px;
  border-radius: 10px;
  gap: 10px;
  margin-top: 50px;
  @media screen and (min-width: 0px) and (max-width: 766px) {
    width: 80%;
  }
  input[type="text"] {
    width: 80%;
    border: none;
    outline: none;
    font-size: 16px;
    background-color: transparent;

    &::placeholder {
      color: #aaa;
      font-family: GT Walsheim Pro;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.02em;
    }
  }
`;

export const SearchIcon = styled(RiSearch2Line)`
  width: 24px;
  height: 24px;
  margin-left: 20px;
  pointer-events: none;
`;

export const SupportListItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
`;
export const SupportListContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 60%;
  height: 137px;
  background-color: #f9f9f9;
  border-radius: 10px;
  margin-top: 20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
`;
export const SupportImage = styled.div``;
export const SupportContent = styled.div``;
export const SupportH3 = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.02em;
  color: #09005b;
`;
export const SupportP1 = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #5e5e5e;
  margin-bottom: 10px;
`;
export const SupportP2 = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;
  margin-top: 10px;
  color: #5e5e5e;
`;
export const SupportP3 = styled.div`
  font-family: GT Walsheim Pro;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.02em;

  color: #0e0e0e;
`;
export const SupportP4 = styled.div`
  width: 184px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 30px;

  background-color: #00a603;
  color: #fff;
`;
export const SupportHelp = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  gap: 20px;
  margin-bottom: 50px;
`;
export const Notification = styled.p`
  background-color: white;
  width: 100%;
  padding: 10px;
  border-radius: 10px;
`;
const CollapsibleContainer = styled.div<{ collapsed: boolean }>`
  width: 100%;
  padding: 10px;
  background-color: ${({ collapsed }) => (collapsed ? "#f9f9f9" : "#ccc")};
  border-radius: 10px;
  margin-top: 10px;
  transition: background-color 0.3s ease;
  cursor: pointer;
`;
